const { createContext } = require("react");

const GlobalStateContext = createContext(null);

export default GlobalStateContext;